import React from 'react';

import Dialog from './Dialog';
import DialogContent from './DialogContent';

import './styles/style.scss';

export { default as DialogHeader } from './DialogHeader';
export { default as DialogContent } from './DialogContent';

export const DialogFooter = props => (
  <DialogContent className="dialog__footer" {...props} />
);
DialogFooter.displayName = 'DialogFooter';

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/index.js